export const getRowColor = ({
  archived,
}: {
  archived: boolean;
}): string | undefined => {
  if (archived) return 'var(--mantine-color-gray-3)';
};
